import { addDays } from './dates';
import type { FormZone } from './vocab';

export const FITNESS_DAYS = 42;
const FATIGUE_DAYS = 7;

export interface FitnessDay {
  date: string;
  load: number;
  fitness: number;
  fatigue: number;
  form: number;
}

export function sumDailyLoads(items: { localDate: string; load: number | null }[]): Map<string, number> {
  const totals = new Map<string, number>();
  for (const { localDate, load } of items) {
    if (load === null) continue;
    totals.set(localDate, (totals.get(localDate) ?? 0) + load);
  }
  return totals;
}

export function fitnessSeries(input: {
  dailyLoads: Map<string, number>;
  from: string;
  to: string;
  seed?: { fitness: number; fatigue: number };
}): FitnessDay[] {
  const days: FitnessDay[] = [];
  let { fitness, fatigue } = input.seed ?? { fitness: 0, fatigue: 0 };
  for (let date = input.from; date <= input.to; date = addDays(date, 1)) {
    const load = input.dailyLoads.get(date) ?? 0;
    const form = fitness - fatigue;
    fitness += (load - fitness) / FITNESS_DAYS;
    fatigue += (load - fatigue) / FATIGUE_DAYS;
    days.push({ date, load, fitness, fatigue, form });
  }
  return days;
}

export function formZone(form: number): FormZone {
  if (form > 5) return 'fresh';
  if (form >= -10) return 'neutral';
  if (form >= -30) return 'productive';
  return 'overreaching';
}
